 
export default {
  global: {
    body: {
      bg: "background",
      color: "text",
      fontWeight: "400",
      minHeight: "100svh",
    },
  },
};
